// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EventOrganizerFieldsFragment = { __typename?: 'EventOrganizer', id: string, type: Types.EventOrganizerType, name: string, email?: string | null, phone_number?: string | null, bio?: string | null, number_of_organized_events: number, number_of_members: number, current_self_onboard_step: Types.EventOrganizerSelfOnboardingStepType, created_at: number, updated_at: number, documents: Array<{ __typename?: 'Media', url: string, description?: string | null, file_name?: string | null, mime_type?: string | null }>, my_roles: Array<{ __typename?: 'TeamMember', id: string, role: Types.TeamMemberRole }> };

export type EventOrganizerTeamMemberFieldsFragment = { __typename?: 'TeamMember', id: string, role: Types.TeamMemberRole };

export type EventOrganizerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EventOrganizerQuery = { __typename?: 'Query', eventOrganizer: { __typename?: 'EventOrganizer', id: string, type: Types.EventOrganizerType, name: string, email?: string | null, phone_number?: string | null, bio?: string | null, number_of_organized_events: number, number_of_members: number, current_self_onboard_step: Types.EventOrganizerSelfOnboardingStepType, created_at: number, updated_at: number, documents: Array<{ __typename?: 'Media', url: string, description?: string | null, file_name?: string | null, mime_type?: string | null }>, my_roles: Array<{ __typename?: 'TeamMember', id: string, role: Types.TeamMemberRole }> } };

export type UpdateEventOrganizerMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  data: Types.UpdateEventOrganizerInput;
}>;


export type UpdateEventOrganizerMutation = { __typename?: 'Mutation', updateEventOrganizer: { __typename?: 'EventOrganizer', id: string, type: Types.EventOrganizerType, name: string, email?: string | null, phone_number?: string | null, bio?: string | null, number_of_organized_events: number, number_of_members: number, current_self_onboard_step: Types.EventOrganizerSelfOnboardingStepType, created_at: number, updated_at: number, documents: Array<{ __typename?: 'Media', url: string, description?: string | null, file_name?: string | null, mime_type?: string | null }>, my_roles: Array<{ __typename?: 'TeamMember', id: string, role: Types.TeamMemberRole }> } };

export const EventOrganizerTeamMemberFieldsFragmentDoc = gql`
    fragment EventOrganizerTeamMemberFields on TeamMember {
  id
  role
}
    `;
export const EventOrganizerFieldsFragmentDoc = gql`
    fragment EventOrganizerFields on EventOrganizer {
  id
  type
  name
  email
  phone_number
  bio
  number_of_organized_events
  number_of_members
  documents {
    url
    description
    file_name
    mime_type
  }
  current_self_onboard_step
  my_roles {
    ...EventOrganizerTeamMemberFields
  }
  created_at
  updated_at
}
    ${EventOrganizerTeamMemberFieldsFragmentDoc}`;
export const EventOrganizerDocument = gql`
    query eventOrganizer($id: ID!) {
  eventOrganizer(id: $id) {
    ...EventOrganizerFields
  }
}
    ${EventOrganizerFieldsFragmentDoc}`;

/**
 * __useEventOrganizerQuery__
 *
 * To run a query within a React component, call `useEventOrganizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventOrganizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventOrganizerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventOrganizerQuery(baseOptions: Apollo.QueryHookOptions<EventOrganizerQuery, EventOrganizerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventOrganizerQuery, EventOrganizerQueryVariables>(EventOrganizerDocument, options);
      }
export function useEventOrganizerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventOrganizerQuery, EventOrganizerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventOrganizerQuery, EventOrganizerQueryVariables>(EventOrganizerDocument, options);
        }
export type EventOrganizerQueryHookResult = ReturnType<typeof useEventOrganizerQuery>;
export type EventOrganizerLazyQueryHookResult = ReturnType<typeof useEventOrganizerLazyQuery>;
export type EventOrganizerQueryResult = Apollo.QueryResult<EventOrganizerQuery, EventOrganizerQueryVariables>;
export const UpdateEventOrganizerDocument = gql`
    mutation updateEventOrganizer($id: ID!, $data: UpdateEventOrganizerInput!) {
  updateEventOrganizer(id: $id, data: $data) {
    ...EventOrganizerFields
  }
}
    ${EventOrganizerFieldsFragmentDoc}`;
export type UpdateEventOrganizerMutationFn = Apollo.MutationFunction<UpdateEventOrganizerMutation, UpdateEventOrganizerMutationVariables>;

/**
 * __useUpdateEventOrganizerMutation__
 *
 * To run a mutation, you first call `useUpdateEventOrganizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventOrganizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventOrganizerMutation, { data, loading, error }] = useUpdateEventOrganizerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEventOrganizerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventOrganizerMutation, UpdateEventOrganizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventOrganizerMutation, UpdateEventOrganizerMutationVariables>(UpdateEventOrganizerDocument, options);
      }
export type UpdateEventOrganizerMutationHookResult = ReturnType<typeof useUpdateEventOrganizerMutation>;
export type UpdateEventOrganizerMutationResult = Apollo.MutationResult<UpdateEventOrganizerMutation>;
export type UpdateEventOrganizerMutationOptions = Apollo.BaseMutationOptions<UpdateEventOrganizerMutation, UpdateEventOrganizerMutationVariables>;